<template>
  <!-- 名录列表 -->
  <div>
    <p class="total">找到{{ total }}条结果</p>
    <van-list
      class="list-box"
      v-model="loading"
      :finished="finished"
      :error="error"
      finished-text="加载完毕"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <MlItem
        class="list-item"
        v-for="item in List"
        :key="item.id"
        :headerPhoto="item.logo"
        :name="item.title"
        @click.native="toDetail(item.id)"
      />
    </van-list>
  </div>
</template>

<script>
import MlItem from "@/views/mobileView/components/listItem/mlItem.vue";
export default {
  name: "Ml",
  components: { MlItem },
  data() {
    return {
      params: {
        pageNo: 0,
        pageSize: 20,
        queryParam: {
          configMap: {
            must: [
              {
                esField: "all",
                queryValue: this.$route.query.paramStr,
              },
              {
                esField: "type",
                queryValue: "6",
              },
            ],
          },
        },
      },
      List: [],
      total: 0,
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.orgList();
    },
    // 搜索名录
    async orgList() {
      const resp = await this.$apis.searchServe.userList(this.params);
      if (resp.resultCode == 200) {
        this.List.push(...resp.data.list);
        this.finished = resp.data.list.length < 20;
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 名录跳转详情
    toDetail(orgId) {
      this.$router.push({
        path: "/appusesinstitutions",
        query: {
          type: 2,
          orgId,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.total {
  text-align: center;
  font-size: 13px;
  color: #999999;
  line-height: 19px;
}
.list-box {
  margin-top: 15px;
  padding: 0 12px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  .list-item {
    border-bottom: 1px solid #eee;
  }
}
</style>
